import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { otSummaryTourSteps } from "./otSummaryTourSteps";
import { useOvertimeTour } from "./useOvertimeTour";

const TOUR_STORAGE_KEY = "hr-overtime-summary-tour-completed";

type OTSummaryTourProps = {
  run: boolean;
  onCallback: (data: { status?: string; type?: string; index?: number }) => void;
};

export function OTSummaryTour({ run, onCallback }: OTSummaryTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type, index: data.index });
  };

  return (
    <Joyride
      steps={otSummaryTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export function useOTSummaryTour() {
  return useOvertimeTour(TOUR_STORAGE_KEY);
}
